import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../store/actions/index';

// import { preRegisterData } from '../../../store/selectors/index';

import SingUpBlockUI from '../../../stories/components/PreRegister/SignUpBlockUI/SingUpBlockUI';

const SignUpBlock = () => {
  const dispatch = useDispatch();

  const onSubscribeUser = userData => dispatch(actions.preRegisterUser(userData));

  const SubscribeUser = (userData) => {
    onSubscribeUser(userData);
  }

  return(
    <SingUpBlockUI 
      onSignUp = {userData => SubscribeUser(userData)}
    />
  );
}

export default SignUpBlock;